<script setup lang="ts">
import { Menu, X } from 'lucide-vue-next';
import { useImpersonation } from '~/composables/api/useImpersonation';
import HeaderActions from './layout/header-actions.vue';

defineProps<{
  sidebarOpen: boolean;
}>();

const emit = defineEmits<{
  toggleSidebar: [];
}>();

const toggleSidebar = () => {
  emit('toggleSidebar');
};

const { isImpersonating } = useAuth();

const { stopImpersonation } = useImpersonation();

const toast = useToast();
const { t } = useI18n();

async function handleStopImpersonation() {
  const { error } = await stopImpersonation();

  if (error.value) {
    toast.add({ title: t('actions.messages.impersonation_stop_error') });
    console.error('Error stopping impersonation:', error.value);
  }
}
</script>
<template>
  <header
    class="fixed top-0 left-0 right-0 z-50 flex items-center justify-between h-16 px-6 bg-white border-b border-gray-200 dark:bg-gray-900 dark:border-gray-700"
  >
    <div class="flex items-center space-x-2">
      <div class="flex items-center justify-center">
        <img
          src="/icons/dark-mode/edifica-v1.svg"
          alt="Edifica Logo"
          class="h-12 w-auto object-contain hidden dark:block"
        />
        <img src="/icons/edifica.svg" alt="Edifica Logo" class="h-12 w-auto object-contain block dark:hidden" />
      </div>
      <div class="flex items-center space-x-4">
        <button class="lg:hidden" @click="toggleSidebar">
          <X v-if="sidebarOpen" class="w-6 h-6" />
          <Menu v-if="!sidebarOpen" class="w-6 h-6" />
        </button>
      </div>
    </div>

    <div class="flex items-center space-x-2">
      <div v-if="isImpersonating">
        <UButton color="warning" @click="handleStopImpersonation">
          <p class="text-white text-xs sm:text-md">{{ t('users.stop_impersonation') }}</p>
        </UButton>
      </div>

      <div class="hidden sm:flex">
        <HeaderActions />
      </div>
    </div>
  </header>
</template>
